import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

import { tokens } from "../tokens/tokens";

// The kit names its own font sizes, leadings, radii and shadows. Without telling
// tailwind-merge, `text-control` and `text-ink` look like two colours and one is dropped.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: Object.keys(tokens.fontSize),
      leading: Object.keys(tokens.lineHeight),
      tracking: Object.keys(tokens.letterSpacing),
      "font-weight": Object.keys(tokens.fontWeight),
      radius: Object.keys(tokens.radius),
      shadow: Object.keys(tokens.shadow),
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
